import { request, requestWithRefresh } from '../utils/request';

export interface AuthCredentials {
    email: string;
    password: string;
}

export interface User {
    email: string;
    createdAt?: string;
    updatedAt?: string;
}
  
export const register = async (credentials: AuthCredentials): Promise<User> => {
    try {
        const response = await request('/auth/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials),
        });
        return response;
    } catch (error: any) {
        const detail = error?.data?.detail || error?.message || 'Registration failed';
        throw new Error(detail);
    }
};

export const login = async (credentials: AuthCredentials): Promise<void> => {
    try {
        await request('/auth/login', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                username: credentials.email,
                password: credentials.password,
            }),
        });
    } catch (error: any) {
        const detail = error?.data?.detail || error?.message || 'Login failed';
        throw new Error(detail);
    }
};

export const getCurrentUser = async (): Promise<User> => {
    try {
        const response = await requestWithRefresh('/auth/me', {
            method: 'GET',
            credentials: 'include',
        });
        return response;
    } catch (error: any) {
        const detail = error?.data?.detail || error?.message || 'Not authenticated';
        throw new Error(detail);
    }
};

export const logout = async (): Promise<void> => {
    try {
        await request('/auth/logout', {
            method: 'POST',
            credentials: 'include',
        });
    } catch (error: any) {
        const detail = error?.data?.detail || error?.message || 'Not authenticated';
        throw new Error(detail);
    }
};
  